import { createThemePageApi, getThemeApi } from "@/services/instantApi";
import Config from "@/config";
import moment from "moment";
import { pageTypeV7 } from "@/modules/Instant/constant";
import store from "@/store";
import { PAGE_CREATION_WORKFLOW_EVENT } from "@/config/constants/trackEventIds";

export const getThemeId = async () => {
  const themeRes = await getThemeApi();
  return themeRes?.data?.themes?.edges?.[0]?.node?.id;
};

export const createThemeAndPageV7 = async ({ pageType, isOnboarding, createByGenerateImage }) => {
  const themeId = await getThemeId();
  if (themeId) {
    const pageRes = await createThemePageApi({
      name: `Untitled - ${moment(new Date()).format("MMM D, HH:mm:ss")}`,
      themeID: themeId,
      type: pageTypeV7[pageType] ?? "GP_STATIC"
    });

    const pageId = pageRes?.data?.themePageCreate?.id;
    if (!pageId) {
      return;
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'page_creation_workflow',
      'data': {
        'event_id': PAGE_CREATION_WORKFLOW_EVENT.DASHBOARD_CREATE_PAGE,
        'store_id': store.state.account.instantShopId || "",
        'page_id': pageId,
        'page_type': pageRes?.data?.themePageCreate?.type || "",
        'time': new Date().toISOString(),
      }
    });

    let query = "";
    if (isOnboarding) {
      query = "&global-style=auto_theme_change";
    }
    if (createByGenerateImage) {
      query = query + "&create-by-image=true";
    }
    window.location.href = Config.getSetting("instantBaseURL") + `/editor/${themeId}/${pageId}?type=gempagesv7${query}`;
  }
};
